import {DataTableConfig} from 'notebook/data-tables/DataTableConstants';
import toColumnLabel from 'notebook/structured-tables/columns/toColumnLabel';
import isSchemaFieldArchived from 'schemas/fields/isSchemaFieldArchived';
import {getFieldForColumn} from 'schemas/fields/SchemaFieldGetters';

export function getColumnNamesForImport(dataTableConfig: DataTableConfig): Array<string> {
  return dataTableConfig.columns
    .filter((column) => {
      const field = getFieldForColumn(dataTableConfig.assaySchema, column);
      return !field || !isSchemaFieldArchived(field);
    })
    .map((column) => toColumnLabel({structuredTableColumn: column, schemas: [dataTableConfig.assaySchema]}))
    .filter((label): label is string => label != null);
}
